<template>
  <v-tooltip
    class="tooltip-icon"
    :top="alignment === alignments.TOP"
    :bottom="alignment === alignments.BOTTOM"
    :left="alignment === alignments.LEFT"
    :right="alignment === alignments.RIGHT"
    :max-width="maxWidth"
    :z-index="999"
  >
    <template v-slot:activator="{ on }">
      <span
        class="info-icon"
        :class="[customClass]"
        v-on="on"
        :style="customStyle"
      >
        <v-icon :color="color" :size="iconSizeRem">{{ icon }}</v-icon>
      </span>
    </template>
    <div>
      <slot></slot>
    </div>
  </v-tooltip>
</template>

<script>
const ALIGNMENTS = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};

export default {
  name: "TooltipIcon",
  props: {
    icon: {
      type: String,
      default: "mdi-information-outline"
    },
    color: {
      type: String,
      default: "orange-1"
    },
    alignment: {
      type: String,
      default: ALIGNMENTS.RIGHT,
      validator: prop => {
        return Object.values(ALIGNMENTS).includes(prop);
      }
    },
    iconSize: {
      type: Number,
      default: 16
    },
    maxWidth: {
      type: Number,
      default: 400
    },
    customClass: {
      type: String,
      default: ""
    },
    customStyle: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    iconSizeRem() {
      return `${this.iconSize / 16}rem`;
    }
  },
  data() {
    return {
      alignments: ALIGNMENTS
    };
  }
};
</script>

<style lang="scss">
.info-icon {
  display: inline-flex;
}
</style>
